import * as m from "./../../dist/es2015/element.js";
export const am5element = m;